import React from 'react';
import {useParams } from 'react-router-dom';
import { DATA_ENTRY, EDIT_WORK, NEW_QA_REVIEW } from '../../../routeNames.js';
import PdfViewer from './PdfViewer';

const NewDataEntry = () => {
    const { job_id } = useParams();

    return (
        <React.Fragment>
            <h1 id='page-title' className='d-none'> {window.location.pathname == DATA_ENTRY ? "MY WORK" : window.location.pathname == EDIT_WORK + job_id ? "VIEW WORK" : window.location.pathname == NEW_QA_REVIEW ? "QA REVIEW" : "GRID"} </h1>

            <div className='ex2' >
                <PdfViewer />
            </div>

        </React.Fragment>
    );
}

export default NewDataEntry;
